<template>
  <div :id="'question-card-' + questionIndex">
    <a-spin v-if="loading"></a-spin>
    <div v-if="!loading && !q" class="question-stem">
      <span>{{ questionIndex }}.&nbsp;</span>
      <span>题目不存在:{{ qid }}</span>
    </div>

    <div v-if="!loading && q">
      <!-- 题干 -->
      <div>
        <div class="question-stem">
          <span>{{ $t('exam.questionIndex', { index: questionIndex, points: q.questionScore }) }} ({{
            getQuestionTypeText(q.questionType)
          }})</span>
          <a-divider type="vertical"></a-divider>
          <div v-html="q.questionStem"></div>
        </div>
      </div>
      <br>
      <div>
        <!-- 单选 -->
        <a-radio-group disabled v-if="q.questionType == 1" v-model="q.questionAnswer">
          <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi + ''">
            <span class="question-letter">{{ index2letter(oi) }} </span>
            <div class="question-options-content">
              <div class="option" v-html="o.item"></div>
            </div>
          </a-radio>
        </a-radio-group>
        <!-- 多选 -->
        <a-checkbox-group disabled v-if="q.questionType == 2" v-model="q.questionAnswerJson">
          <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
            <span class="question-letter">{{ index2letter(oi) }} </span>
            <div class="question-options-content">
              <div class="option" v-html="o.item"></div>
            </div>
          </a-checkbox>
        </a-checkbox-group>
        <!-- 判断题 -->
        <a-radio-group disabled v-if="q.questionType == 3" v-model="q.questionAnswer">
          <a-radio value="true"><span class="question-letter">{{ index2letter(0) }}</span>{{ $t('exam.right') }}</a-radio>
          <a-radio value="false"><span class="question-letter">{{ index2letter(1) }}</span>{{ $t('exam.wrong')
          }}</a-radio>
        </a-radio-group>
        <!-- 主观题 阅读分析-->
        <!-- <div v-if="q.questionType == 5 || q.questionType == 6">
        <a-textarea readonly :auto-size="{ minRows: 5, maxRows: 20 }" :placeholder="$t('exam.answerArex')"></a-textarea>
      </div> -->

        <!-- 编程题 -->
        <!-- OJ编程题 -->
        <div v-if="q.questionType == 7 || q.questionType == 8">
          <a-button type="primary" size="large" @click="openEditor(q, false)">{{ $t('exam.viewTemplate') }}</a-button>
          <a-divider type="vertical" v-if="q.questionAnalysis"></a-divider>
          <a-button type="primary" size="large" v-if="q.questionAnalysis" @click="openEditor(q, true)">{{
            $t('exam.viewTemplate')
          }}</a-button>
        </div>
      </div>
    </div>
    <a-modal :width="'100%'" :visible="editorVisible" :maskClosable="false" :dialogStyle="{ top: 0 }"
      :bodyStyle="{ padding: 0 }" :destroyOnClose="true" :footer="null" @cancel="editorVisible = false">
      <a-icon slot="closeIcon" type="close-circle" theme="twoTone" style="font-size: 30px; line-height: 70px" />
      <div slot="title">
        <a-row>
          <a-col :span="8">
            <span>{{ questionInfo.questionName }}</span>
          </a-col>
          <a-col :span="8">
            <a-button type="primary" v-if="questionInfo.questionType != 8" @click="viewQuestionStem(questionInfo)">{{
              $t('exam.viewQuestionStem') }}</a-button>
          </a-col>
        </a-row>
      </div>
      <iframe :src="editorUrl" id="player" frameborder="0" width="100%" style="height: calc(100vh - 70px)"
        scrolling="no"></iframe>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, putAction } from '@/api/manage'
import { examMixins } from '@/utils/examMixins'

export default {
  name: 'QuestionCard',
  mixins: [examMixins],
  data() {
    return {
      qid: '',
      q: null,
      loading: true
    }
  },
  props: {
    questionIndex: {
      type: Number,
      default: 0,
    },
    questionInfo: {
      type: Object,
    },
  },
  watch: {
    questionInfo: {
      handler(newValue, oldValue) {
        this.init()
      }
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.questionInfo) {
        if (this.questionInfo.questionStem) {
          this.q = this.questionInfo
          this.parseQuestion(this.q)
        } else {
          this.getQuestionInfo(this.questionInfo.id)
        }
      } else {
      }
    },
    parseQuestion(q) {
      //解析题目选项
      if (q.questionOptions != null && typeof q.questionOptions == 'string') {
        q.questionOptions = JSON.parse(q.questionOptions)
      }
      //解析答案
      if (q.questionType == 2 && q.questionAnswer && typeof q.questionAnswer == 'string') {
        q.questionAnswerJson = JSON.parse(q.questionAnswer)
      }
      this.loading = false
    },
    getQuestionInfo(id) {
      this.qid = id
      this.loading = true
      getAction('/teaching/teachingQuestion/getQuestion', { questionId: id }).then(res => {
        this.loading = false
        if (res.success) {
          this.q = res.result
          this.parseQuestion(this.q)
        } else {

        }
      }).catch(r => {
        console.log(r);
      })
    },
  },
}
</script>

<style lang="less" scoped>
.question-stem {
  width: 100%;
  max-height: 500px;
  overflow: auto;

  span,
  >div {
    display: inline-block;
    vertical-align: top;
  }
}

.ant-radio-wrapper,
.ant-checkbox-wrapper {
  display: block !important;
  margin-left: 0px;
  margin-bottom: 0.5em;

  span {
    color: black !important;
    cursor: pointer;
  }
}

.question-options-content {
  display: inline-block;
  color: black !important;
  cursor: pointer;
}

.question-letter {
  vertical-align: top;
  margin-right: 10px;
}

/deep/.ant-checkbox,
/deep/.ant-radio {
  vertical-align: top;
  top: 0.2em;
}
</style>